(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_cart-products"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const cartItems = document.querySelectorAll('.cart-item');

    const updateLineItem = (lineNumber, quantity) => {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: lineNumber,
          quantity: quantity,
        }),
      })
        .then((res) => res.json())
        .then((cart) => {
          const cartItem = document.querySelector(`.cart-item[data-line="${lineNumber}"]`);
          const input = cartItem?.querySelector('input[name="updates[]"]');
          const errorMessageEl = cartItem?.querySelector('.quantity-error-message');

          // Clear previous error message
          if (errorMessageEl) {
            errorMessageEl.hidden = true;
            errorMessageEl.textContent = '';
          }

          // If Shopify returned an error (e.g., exceeding inventory)
          if (!cart.items && cart.message) {
            if (errorMessageEl) {
              errorMessageEl.textContent = 'No more quantity available at this time!';
              errorMessageEl.hidden = false;
            }

            // Optionally, reset input to current quantity from cart (from original DOM input value)
            // OR disable the plus button if needed
            if (input) {
              // fallback: keep the current value (don’t update)
              input.value = input.value; // Or you could re-fetch cart.js and set exact value
            }

            console.error('Cart error:', cart.message);
            return;
          }

          // Success: update cart UI
          if (Array.isArray(cart.items)) {
            updateCartUI(cart);
          }
        })
        .catch((error) => {
          console.error('Cart update failed:', error);
        });
    };

    // Loop through each cart item
    cartItems.forEach((item) => {
      const minusBtn = item.querySelector('button[name="minus"]');
      const plusBtn = item.querySelector('button[name="plus"]');
      const removeBtn = item.querySelector('.cart-remove-btn');
      const input = item.querySelector('input[name="updates[]"]');

      if (!input) return;

      const line = parseInt(input.getAttribute('data-cart-line'), 10);

      input.addEventListener('blur', () => {
        const newQty = parseInt(input.value, 10);

        // Prevent invalid numbers or NaNs
        if (isNaN(newQty) || newQty < 0) {
          input.value = input.value; // reset to previous valid value
          return;
        }

        updateLineItem(line, newQty);
      });
      input.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          input.blur(); // Triggers the blur handler above
        }
      });
      if (minusBtn) {
        minusBtn.addEventListener('click', () => {
          let newQty = Math.max(parseInt(input.value, 10) - 1, 0);
          updateLineItem(line, newQty);
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', () => {
          let newQty = parseInt(input.value, 10) + 1;
          updateLineItem(line, newQty);
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener('click', () => {
          const removeUrl = removeBtn.getAttribute('data-remove-url');
          if (removeUrl) {
            window.location.href = removeUrl; // full-page redirect
          } else {
            updateLineItem(line, 0); // AJAX fallback if URL is not present
          }
        });
      }
    });

    // On page load, update UI with current cart values
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        if (cart && Array.isArray(cart.items)) {
          updateCartUI(cart);
        } else if (cart && cart.status && cart.message) {
          alert(cart.message); // optional: show the error message to user
          console.error('Cart update error:', cart.message);
        } else {
          console.error('Unexpected cart response:', cart);
        }
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
      });

    // Function to update the UI
    function updateCartUI(cart) {
      let total = 0;

      cart.items.forEach((item, index) => {
        const cartItem = document.querySelector(`.cart-item[data-line="${index + 1}"]`);
        if (!cartItem) return;

        const input = cartItem.querySelector('input[name="updates[]"]');
        const priceEls = cartItem.querySelectorAll('.cart-item-total-price'); // ✅ fix here

        total += item.line_price;

        if (input) input.value = item.quantity;

        priceEls.forEach((el) => {
          el.textContent = `$${(item.line_price / 100).toFixed(2)}`;
        });
      });

      const formattedTotal = `$${(total / 100).toFixed(2)}`;
      const totalComponents = document.querySelectorAll('text-component[ref="cartTotal"]');
      totalComponents.forEach((el) => {
        el.setAttribute('value', formattedTotal);
        el.textContent = formattedTotal;
      });

      const cartPriceEl = document.querySelector('.cart-price');
      if (cartPriceEl) {
        cartPriceEl.textContent = formattedTotal;
      }
      const cartBadge = document.querySelector('.cart-count-badge');
      if (cartBadge) {
        cartBadge.textContent = cart.item_count;
      }
      if (cart.items.length === 0) {
        document.querySelector('.cart-items-wrapper').innerHTML = '<p>Your cart is empty.</p>';
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["blog-article"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const articleBlocks = document.querySelectorAll('.blog-article-block');

    articleBlocks.forEach((block) => {
      const tabButtons = block.querySelectorAll('.tab-button');
      const tabPanels = block.querySelectorAll('.tab-panel');

      tabButtons.forEach((button) => {
        button.addEventListener('click', function () {
          const targetTag = this.dataset.tag;

          // Remove active class from all buttons and panels
          tabButtons.forEach((btn) => btn.classList.remove('active'));
          tabPanels.forEach((panel) => panel.classList.remove('active'));

          // Add active class to clicked button
          this.classList.add('active');

          // Show corresponding panel
          const targetPanel = block.querySelector(`.tab-panel[data-tag="${targetTag}"]`);
          if (targetPanel) {
            targetPanel.classList.add('active');
          }
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const resultsList = document.getElementById('ResultsList');
    if (!resultsList) return;

    const productCache = {};

    // Update a single product card image based on data-default-variant-id
    const updateCardImage = async (card) => {
      const productCardLink = card.querySelector('product-card-link') || card.closest('product-card-link');
      if (!productCardLink) return;

      const imgElement = card.querySelector('img');
      const productUrl = productCardLink.querySelector('a')?.href;
      if (!imgElement || !productUrl) return;

      const handleMatch = productUrl.match(/\/products\/([a-zA-Z0-9-_]+)/);
      if (!handleMatch) return;
      const productHandle = handleMatch[1];

      // Fetch product JSON if not cached
      let productData = productCache[productHandle];
      if (!productData) {
        try {
          const response = await fetch(`/products/${productHandle}.js`);
          if (!response.ok) return;
          productData = await response.json();
          productCache[productHandle] = productData;
        } catch (err) {
          console.error('Failed to fetch product data:', err);
          return;
        }
      }

      // Get the variant selected by filter
      const variantId = card.getAttribute('data-default-variant-id');
      if (!variantId) return;

      const variant = productData.variants.find((v) => v.id.toString() === variantId);
      if (variant?.featured_image) {
        imgElement.src = variant.featured_image.src;
        imgElement.srcset = variant.featured_image.src;
        productCardLink.setAttribute('data-featured-media-url', variant.featured_image.src);
      }
    };

    // Update all product cards in results list
    const updateAllCards = () => {
      resultsList.querySelectorAll('product-card').forEach(updateCardImage);
    };

    // Initial update on page load
    updateAllCards();

    // Observe changes inside ResultsList (filter changes)
    const observer = new MutationObserver(() => {
      // When filters update results, update all product images
      updateAllCards();
    });

    observer.observe(resultsList, {
      childList: true, // detect added/removed product cards
      subtree: true, // include nested elements
      attributes: true, // detect changes to data-default-variant-id
      attributeFilter: ['data-default-variant-id'], // only watch variant changes
    });
  });
  document.addEventListener('DOMContentLoaded', function () {
    // Find the target facet panel
    const colorFacet = document.querySelector('[data-filter-param-name="filter-v-option-color"] .facets__panel');
    if (!colorFacet) return;

    const label = colorFacet.querySelector('.facets__label');
    if (!label) return;

    // Wrap the label in a flex container so we can align hover text beside it
    const wrapper = document.createElement('div');
    wrapper.className = 'facets__label-wrapper';
    label.parentNode.insertBefore(wrapper, label);
    wrapper.appendChild(label);

    // Create an element for showing hovered color value
    const hoverValue = document.createElement('span');
    hoverValue.className = 'facet-hover-value text-caption-1-regular text-neutral-faded';
    wrapper.appendChild(hoverValue);

    // Add hover listeners to each color <li> item
    const colorItems = colorFacet.querySelectorAll('.facets__inputs-list-item');

    colorItems.forEach((item) => {
      // Find the inner swatch element that holds the color name
      const swatch = item.querySelector('.swatch-item');
      if (!swatch) return; // skip if not found

      const colorName = swatch.getAttribute('data-title');

      item.addEventListener('mouseenter', () => {
        hoverValue.textContent = colorName;
        hoverValue.classList.add('visible');
      });

      item.addEventListener('mouseleave', () => {
        hoverValue.textContent = '';
        hoverValue.classList.remove('visible');
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-card-swatches"] && !Shopify.designMode) return;
  try {
    class VariantUpdate {
  constructor() {
    this.init();
    this.observeDomChanges();
  }

  init() {
    const cards = document.querySelectorAll("product-card.product-card:not([data-variant-init])");

    cards.forEach((card) => {
      this.setupCard(card);
      card.dataset.variantInit = "true";
    });
  }

  resetOutlines(swatchItems) {
    swatchItems.forEach((swatch) => {
      swatch.style.outlineColor = "rgb(2, 2, 2)";
    });
  }

  highlightDefaultVariant(swatchItems, defaultVariantId) {
    if (!defaultVariantId) return;

    swatchItems.forEach((swatch) => {
      if (swatch.dataset.variantId === defaultVariantId) {
        swatch.style.outlineColor = "rgb(178, 211, 1)";
      }
    });
  }

  handleSwatchClick(swatch, swatchItems, image, productLink) {
    this.resetOutlines(swatchItems);
    swatch.style.outlineColor = "rgb(178, 211, 1)";

    if (image) {
      const variantImage = `${window.location.protocol}//${window.location.host}/cdn/shop/${swatch.dataset.image}`;
      image.src = variantImage;
      image.srcset = variantImage;
    }

    if (productLink) {
      const url = new URL(productLink.href);
      url.searchParams.set("variant", swatch.dataset.variantId);
      productLink.href = url.toString();
    }
  }

  setupCard(card) {
    const swatchItems = card.querySelectorAll("button.swatch-item");
    if (!swatchItems.length) return;

    const productLink = card.querySelector("a");
    const image = card.querySelector("img");
    const defaultVariantId = card.dataset.defaultVariantId;

    this.highlightDefaultVariant(swatchItems, defaultVariantId);

    swatchItems.forEach((swatch) => {
      if (swatch.dataset.listenerBound) return; // Prevent duplicates

      swatch.addEventListener("click", () => {
        this.handleSwatchClick(swatch, swatchItems, image, productLink);
      });

      swatch.dataset.listenerBound = "true";
    });
  }

  observeDomChanges() {
    const observer = new MutationObserver(() => {
      this.init(); // Only updates new cards
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new VariantUpdate();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tabs-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.tabs-block').forEach((tabsContainer) => {
      const tabItems = tabsContainer.querySelectorAll('.tab-item');
      const tabHead = tabsContainer.querySelector('.tabs-head');
      const tabMetas = tabsContainer.querySelectorAll('.tab-meta');

      const tabList = [];

      // Internal tabs
      tabItems.forEach((tabItem, index) => {
        const tabContent = tabItem.querySelector('.tabcontent');
        if (!tabContent) return;

        const tabId = tabContent.getAttribute('id');
        const label = tabContent.getAttribute('data-label') || `Tab ${index + 1}`;
        tabList.push({ id: tabId, label, isExternal: false });
      });

      // External tabs
      tabMetas.forEach((meta) => {
        const tabId = meta.dataset.id;
        const label = meta.dataset.label || 'External Tab';
        const isExternal = meta.dataset.external === 'true';

        const alreadyAdded = tabList.some((t) => t.id === tabId);
        if (!alreadyAdded) {
          tabList.push({ id: tabId, label, isExternal });
        }
      });

      // Build tab header links
      tabList.forEach((tab, index) => {
        const link = document.createElement('a');
        link.className = 'tablinks';
        link.textContent = tab.label;
        link.setAttribute('href', `#${tab.id}`);
        link.dataset.tab = tab.id;

        // Apply active class to the first tab (internal or external)
        if (index === 0) {
          link.classList.add('active');

          // If internal tab, show content
          if (!tab.isExternal) {
            const activeItem = tabsContainer.querySelector(`#${tab.id}`)?.closest('.tab-item');
            if (activeItem) activeItem.style.display = 'block';
          }
        }

        link.addEventListener('click', function (e) {
          e.preventDefault();

          if (tab.isExternal) {
            const target = document.getElementById(tab.id);
            if (target) {
              target.scrollIntoView({ behavior: 'smooth' });
            }
            return;
          }

          // Hide all tab-items
          tabItems.forEach((item) => (item.style.display = 'none'));
          tabHead.querySelectorAll('.tablinks').forEach((lnk) => lnk.classList.remove('active'));

          // Show target tab-item
          const targetTab = document.getElementById(tab.id);
          if (targetTab) {
            const parentTabItem = targetTab.closest('.tab-item');
            if (parentTabItem) parentTabItem.style.display = 'block';
          }

          this.classList.add('active');
        });

        tabHead.appendChild(link);
        // Setup mapping from tabId to link element
        const tabLinkMap = {};
        // 1. Build a map of external tab IDs and their real DOM section
        const externalTabs = tabList.filter((tab) => tab.isExternal);
        const sectionMap = {};

        externalTabs.forEach((tab) => {
          const section = document.getElementById(tab.id);
          if (section) {
            sectionMap[tab.id] = section;
          }
        });

        // 2. On scroll, update active tab based on which section is next
        function updateActiveTabOnScroll() {
          let closestTabId = null;
          let minDistance = window.innerHeight;

          Object.entries(sectionMap).forEach(([tabId, section]) => {
            const rect = section.getBoundingClientRect();
            if (rect.top >= 0 && rect.top < minDistance) {
              minDistance = rect.top;
              closestTabId = tabId;
            }
          });

          if (closestTabId) {
            tabHead.querySelectorAll('.tablinks').forEach((lnk) => lnk.classList.remove('active'));

            const activeLink = tabHead.querySelector(`[data-tab="${closestTabId}"]`);
            if (activeLink) {
              activeLink.classList.add('active');
            }
          }
        }

        // 3. Attach scroll listener (debounced for performance)
        window.addEventListener('scroll', () => {
          window.requestAnimationFrame(updateActiveTabOnScroll);
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["value-prop-banner"] && !Shopify.designMode) return;
  try {
    let slideIndex = 0;

  if (window.innerWidth <= 768) {
    showSlides();
  }

  function showSlides() {
    let i;
    let slides = document.getElementsByClassName("value-prop-banner__item");

    for (i = 0; i < slides.length; i++) {
      slides[i].classList.remove("active");
    }

    slideIndex++;
    if (slideIndex > slides.length) {
      slideIndex = 1
    }
    slides[slideIndex - 1].classList.add("active");
    setTimeout(showSlides, 4000);
  }
  } catch(e) { console.error(e); }
})();

})();
